import { createRoot } from 'react-dom/client';
import { LedgerProvider } from './hooks/use-ledger-store';
import { LoadingProvider } from './hooks/use-loading';
import { ToastProvider } from './hooks/use-toast';
import App from './App';
import type { ViewType } from './types';
// CSS 經由 frontend/index.html <link> 標籤引入，不需在 JS bundle 處理

/**
 * 功能：將 URL 路徑對應至前端 ViewType（與 entry-server.tsx 保持一致）
 * @param {string} pathname URL 路徑
 * @returns {ViewType} 對應的視圖識別碼
 */
function urlToView(pathname: string): ViewType {
  const map: Record<string, ViewType> = {
    '/': 'dashboard',
    '/login': 'login',
    '/register': 'register',
    '/expenses': 'expenses',
    '/add-expense': 'add-expense',
    '/settlements': 'settlements',
    '/accounts': 'accounts',
    '/members': 'members',
    '/search': 'search',
    '/history': 'history',
  };
  const exact = map[pathname];
  if (exact) return exact;
  if (pathname.startsWith('/expenses/')) return 'expenses';
  if (pathname.startsWith('/settlements/')) return 'settlements';
  if (pathname.startsWith('/history/')) return 'history';
  return 'dashboard';
}

const initialView = urlToView(window.location.pathname);

createRoot(document.getElementById('root')!).render(
  <LoadingProvider>
    <ToastProvider>
      <LedgerProvider initialView={initialView}>
        <App />
      </LedgerProvider>
    </ToastProvider>
  </LoadingProvider>,
);

// PWA Service Worker registration.
// Keep activation stable: do not force page reload on controller changes.
async function registerServiceWorker(): Promise<void> {
  try {
    const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });

    registration.addEventListener('updatefound', () => {
      const installing = registration.installing;
      if (!installing) return;

      installing.addEventListener('statechange', () => {
        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
          console.info('[SW] A new version is installed and will apply after reload.');
        }
      });
    });

    void registration.update();
  } catch (err) {
    console.warn('[SW] Registration failed:', err);
  }
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void registerServiceWorker();
  });
}
